module.exports = __webpack_public_path__ + "img/jiangheen.ed14a439.jpg";